import Vue from 'vue';
import {
  createUserApi,
  emailValidationApi,
  resendValidationApi
} from '../../api/sign-up';
import { GLOBAL_ERROR } from '../../utils/constants';

export function createUser({ commit, state, rootGetters }, password) {
  return new Promise(async (resolve, reject) => {
    const brandName = rootGetters['user/brandName']();
    try {
      commit('setState', ['creatingUser', true]);
      const response = await createUserApi({
        email: state.email,
        firstName: state.firstName,
        lastName: state.lastName,
        password,
        brandName
      });
      commit('setState', ['creatingUser', false]);
      resolve({
        status: response.status,
        validateEmailUrl: response.validateEmailUrl,
        firstName: response.firstName,
        lastName: response.lastName
      });
    } catch (err) {
      commit('setCreateUserError', err.message);
      commit('setState', ['creatingUser', false]);
      reject();
    }
  });
}

export function validateEmail({ commit, state }, { token, tokenType }) {
  return new Promise(async (resolve, reject) => {
    try {
      if (state.pinAttempts > state.pinAllowedAttempts) {
        return reject();
      }
      commit('increasePinAllowedAttempts');
      commit('setState', ['sendingSignUpPin', true]);
      const response = await emailValidationApi(
        token,
        parseInt(state.pin),
        tokenType
      );
      commit('setPinAttempts', {
        attempt: response.attempt,
        maxAttempt: response.maxAttempt
      });
      if (response.status === 'failure') {
        commit('setSignUpPinFailureReason', response.reason);
        commit('setState', ['sendingSignUpPin', false]);
        return reject();
      }
      commit('setState', ['sendingSignUpPin', false]);
      resolve();
    } catch (err) {
      commit('setSignUpPinError', err.message);
      commit('setState', ['sendingSignUpPin', false]);
      reject();
    }
  });
}

export function resendValidation(
  { commit, dispatch },
  { oldToken, oldTokenType }
) {
  return new Promise(async (resolve, reject) => {
    try {
      commit('setState', ['resendingSignUpPin', true]);
      const response = await resendValidationApi(oldToken, oldTokenType);
      commit('setState', ['resendingSignUpPin', false]);
      resolve(response.validateEmailUrl);
    } catch (err) {
      // eslint-disable-next-line
      console.error(err);
      Vue.prototype.$euiNotifications.emit({
        notification: GLOBAL_ERROR,
        action: () => dispatch('resendValidation')
      });
      commit('setState', ['resendingSignUpPin', false]);
      reject();
    }
  });
}
